import { FunctionComponent } from 'preact';
import cn from 'classnames';

export interface TypographyProps {
  variant: 'label' | 'button' | 'title' | 'body' | 'caption';
  size?: 'large' | 'medium' | 'small';
  color?:
    | 'primary'
    | 'secondary'
    | 'inherit'
    | 'subtitle-text'
    | 'inverted'
    | 'tag-text'
    | 'white';
  title?: string;
  className?: string;
  bold?: boolean;
}

export const Typography: FunctionComponent<TypographyProps> = ({
  variant,
  color = 'primary',
  size = 'medium',
  bold = false,
  title,
  children,
  className,
  ...rest
}) => {
  return (
    <span
      className={cn(
        'vgp-typography',
        `vgp-typography-${variant}`,
        `vgp-typography-color-${color}`,
        `vgp-typography-${variant}-${size}`,
        className,
        { bold: bold }
      )}
      title={title}
      {...rest}
    >
      {children}
    </span>
  );
};
